import { useAuth0 } from '@auth0/auth0-react';

export function useRole() {
  const { user } = useAuth0();
  const roles = user?.['https://classic-mods-app/claims/roles'] || [];
  return {
    isAdmin: roles.includes('admin'),
    isUser: roles.includes('user') || roles.length === 0,
  };
}
